<template>
    <el-tooltip class="item" effect="dark" placement="top">
        <div slot="content">
            <strong>Authentication</strong>
            <br>
            <small>
                This will redirect you to {{ integrationName }} for authentication.
            </small>
        </div>
        <el-button size="mini btn-text" @click="oauth()">
            <template v-if="hasAccessToken">
                <span>Re-Authenticate</span>
            </template>
            <template v-else-if="!otherCrmIsEnabled">
                <span>Authenticate</span>
            </template>
        </el-button>
    </el-tooltip>
</template>
<script>
export default {
    data() {
        return {}
    },
    props: {
        integrationName: {
            type: String,
            required: true
        },
        oauth: {
            type: Function,
            required: true
        },
        hasAccessToken: {
            type: Boolean,
            default: false
        },
        otherCrmIsEnabled: {
            type: Boolean,
            default: false
        }
    }
}
</script>
